/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import NotificationBanner from "../../components/Notifications/NotificationBanner";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/Context";
import sendLogError from "../../sendLogError";

/* MODULE IMPORTS */
import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/
import TabelaCandidatos from "./TabelaCandidatos";

/* CSS IMPORT */
import "./Eleicoes.css";
import votarBtnImg from "../../images/votarBtn.png";
import eleicoesWhiteImg from "../../images/EleicoesWhite.png";
import arrowVotarImg from "../../images/ArrowVotar.png";
import arrowCloseWhiteImg from "../../images/ArrowCloseWhite.png";
import saberMaisBtnImg from "../../images/saberMaisBtn.png";
import duvidasEleicoesImg from "../../images/duvidasEleicoes.png";
import duvidasEleicoesMobileImg from "../../images/duvidasEleicoesMobile.png";
import loadingImg from "../../images/loading.svg";

var reactPlugin = new ReactPlugin();

export class Eleicoes extends Component {
  static displayName = Eleicoes.name;

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      loading: true,
      actualDate: null,
      startDate: null,
      endDate: null,
      votePortalUrl: null,
      listasAssembleiaRepresentantes: null,
      listasAssembleiaGeral: null,
      showVotarMobile: true,
      canVote: null,
      voteSubmitted: false,
    };
  }

  componentDidMount() {
    this.GetElectionDates();
    this.GetCandidatesList();
  }

  errorLoading() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  renderEleicoesPage(state) {
    var isSegundaFase = true;
    var isSemanaVotacao = false;

    if (this.state.actualDate && this.state.endDate && this.state.startDate) {
      var dateCheck = new Date(this.state.actualDate);
      var startSemanaVotacao = new Date(this.state.startDate);
      var endSemanaVotacao = new Date(this.state.endDate);

      isSemanaVotacao = dateCheck > startSemanaVotacao && dateCheck < endSemanaVotacao;
    }

    const showVoteButton = isSemanaVotacao;

    return (
      <main className="main">
        <NotificationBanner />
        <div className="title-bar">
          <div className="title eleicoes-title">Eleição dos Órgãos Associativos 2026-2029</div>
        </div>
        {showVoteButton && (
          <div className="convocatoria-bar voto-bar">
            <div className="card-new">
              <table className="card-new-table">
                <tbody>
                  <tr>
                    <th className="card-new-title">
                      Eleições <br></br>2026-2029
                    </th>
                    <th style={{ paddingLeft: "20px" }}>
                      <div
                        className={
                          this.state.canVote === true
                            ? "card-disclaimer"
                            : "card-disclaimer full-width"
                        }>
                        {this.state.canVote === true && (
                          <div>
                           Depois de clicar em "Votar" receberá um código de segurança no seu telemóvel,
                           que terá que introduzir para aceder à plataforma de voto.
                          </div>
                        )}

                        {this.state.canVote === false && this.state.voteSubmitted === true && (
                          <div>
                            Direito de voto já exercido.
                          </div>
                        )}

                        {this.state.canVote === false && this.state.voteSubmitted === false && (
                          <div>
                            Não estão reunidas as condições necessárias para exercer o direito de voto.
                            Para mais informações, contacte o seu Gestor Mutualista.
                          </div>
                        )}
                      </div>
                    </th>
                    {this.state.canVote === true && this.state.voteSubmitted === false && (
                      <th>
                        <div className="button-vote">
                          <img
                            src={votarBtnImg}
                            style={{ cursor: "pointer", width: "122px" }}
                            onClick={() => window.open(this.state.votePortalUrl, "_blank")}></img>
                        </div>
                      </th>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        {showVoteButton && (
          <div
            id="votar-mobile"
            className={
              this.state.showVotarMobile
                ? "footer-votar d-md-none hide"
                : "remove footer-votar d-md-none hide"
            }>
            <div>
              <img
                className="imagem-eleicoes"
                src={eleicoesWhiteImg}></img>
            </div>
            <div className="eleicoes-mobile-title">
              Eleições <br></br> 2026-2029
            </div>
            <div>
              <div
                className="botao-votar-mobile"
                onClick={() => window.open(this.state.votePortalUrl, "_blank")}>
                Votar
                <img width="15px" src={arrowVotarImg}></img>
              </div>
            </div>
            <div className="votar-mobile-close">
              <img
                width="15px"
                style={{ cursor: "pointer" }}
                src={arrowCloseWhiteImg}
                onClick={() =>
                  this.setState({
                    showVotarMobile: false,
                  })
                }></img>
            </div>
          </div>
        )}
        {showVoteButton && (
          <div className="convocatoria-bar">
            <div className="card-new card-new-mobile card-convocatoria-mobile card-votar-mobile">
              <div className="card-new-table">
                <div className="card-new-title">
                  <div className="tableCapitalCerto-title-inactive">Eleições 2026-2029</div>
                </div>
                {this.state.canVote === true && (
                  <div className="tableCapitalCerto-amount">
                    Depois de clicar em "Votar" receberá um código de segurança no seu telemóvel,
                    que terá que introduzir para aceder à plataforma de voto.
                  </div>
                )}
                {this.state.canVote === false && this.state.voteSubmitted === true && (
                  <div className="tableCapitalCerto-amount">
                    Direito de voto já exercido.                   
                  </div>
                )}
                { this.state.canVote === false && this.state.voteSubmitted === false && (
                  <div className="tableCapitalCerto-amount">
                    Não estão reunidas as condições necessárias para exercer o direito de voto. 
                    Para mais informações, contacte o seu Gestor Mutualista.
                  </div>
                )}
                {this.state.canVote === true && this.state.voteSubmitted === false && (
                  <div className="button-vote">
                    <img
                      src={votarBtnImg}
                      onClick={() => window.open(this.state.votePortalUrl, "_blank")}></img>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {showVoteButton && (<div className="sub-title-bar">
          <div className="sub-title eleicoes-sub-title black">
            Vote por si e pelo futuro de todos.
          </div>
        </div>)}

        {isSegundaFase &&
          this.state.listasAssembleiaGeral &&
          this.state.listasAssembleiaRepresentantes && (
            <div>
              <div className="sub-title-bar">
                <div className="sub-title eleicoes-sub-title">
                  Conheça a composição e o programa das listas candidatas aos Órgãos Associativos:
                </div>
              </div>
              <TabelaCandidatos
                listasAssembleiaGeral={this.state.listasAssembleiaGeral}
                listasAssembleiaRepresentantes={
                  this.state.listasAssembleiaRepresentantes
                }></TabelaCandidatos>
            </div>
          )}

        <div className="convocatoria-bar">
          <div className="card-new">
            <table className="card-new-table">
              <tbody>
                <tr>
                  <th className="card-new-title">
                    Eleições <br></br>2026-2029
                  </th>
                  <th style={{ paddingLeft: "20px" }}>
                    <div className="card-disclaimer">
                      Conheça a Convocatória, Regulamento e todas as informações referentes ao
                      processo eleitoral.
                    </div>
                  </th>
                  <th>
                    <div className="">
                      <img
                        src={saberMaisBtnImg}
                        style={{ cursor: "pointer", width: "160px" }}
                        onClick={() =>
                          window.open(
                            "https://www.montepio.org/eleicao-orgaos-associativos-2026-29/",
                            "_blank",
                          )
                        }></img>
                    </div>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="convocatoria-bar">
          <div className="card-new card-new-mobile card-convocatoria-mobile">
            <div className="card-new-table">
              <div className="card-new-title">
                <div className="tableCapitalCerto-title-inactive">Eleições 2026-2029</div>
              </div>
              <div className="tableCapitalCerto-amount">
                Conheça a Convocatória, Regulamento e todas as informações referentes ao processo
                eleitoral.
              </div>
              <div className="tableCapitalCerto-amount"></div>
              <div className="tableSaberMais">
                <img
                  src={saberMaisBtnImg}
                  style={{ cursor: "pointer", width: "160px" }}
                  onClick={() =>
                    window.open(
                      "https://www.montepio.org/eleicao-orgaos-associativos-2026-29/",
                      "_blank",
                    )
                  }></img>
              </div>
            </div>
          </div>
        </div>
        <div className="convocatoria-bar duvidas-bar">
          <div className="card-new card-duvidas">
            <table className="card-new-table">
              <tbody>
                <tr>
                  <th className="no-padding">
                    <img
                      style={{ width: "206px" }}
                      src={duvidasEleicoesImg}></img>
                  </th>
                  <th className="duvidas-column no-padding" style={{ paddingLeft: "20px" }}>
                    <div className="duvidas">Tem dúvidas?</div>
                                    <div className="contacto">
                                        Linha de Apoio ao Associado - Tel. 213 248 112 <br></br>
                                        Atendimento personalizado, dias úteis das 09h às 21h. Custo
                      de chamada para a rede fixa nacional</div>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="modalidades modalidades-mobile duvidas-bar">
          <div className="">
            <div className="">
              <img
                style={{ width: "320px" }}
                src={duvidasEleicoesMobileImg}></img>
            </div>

            <div className="duvidas-column duvidas-column-mobile ">
              <div className="duvidas">Tem dúvidas?</div>
              <div className="contacto">
                Linha de Apoio ao Associado <br></br>- Tel. 213 248 112
              </div>
              <div className="horario">
                {isSemanaVotacao ? "Dias úteis das 9h às 0h" : "Dias úteis das 9h às 21h"}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  render() {
    //Funcao responsavel por mostrar e esconder o botao de votar fixo no rodapé dos smartphones
    var myScrollFunc = function () {
      var y = window.scrollY;
      if (document.getElementById("votar-mobile")) {
        if (y >= 415) {
          document.getElementById("votar-mobile").classList.add("show");
          document.getElementById("votar-mobile").classList.remove("hide");
        } else {
          document.getElementById("votar-mobile").classList.add("hide");
          document.getElementById("votar-mobile").classList.remove("show");
        }
      }
    };

    window.addEventListener("scroll", myScrollFunc);

  
    console.log("this.state.actualDate: ", this.state.actualDate);
    console.log("this.state.endDate: ", this.state.endDate);
    let contents = this.state.loading ? (
      <div className="main-page-loading">
        <div className="loading">
          <img src={loadingImg}></img>
        </div>
      </div>
    ) : this.state.error ? (
      this.errorLoading()
    ) : (
      this.renderEleicoesPage(this.state)
    );
    return <div>{contents}</div>;
  }

  async GetElectionDates() {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`
        };

        const response = await fetch("/Elections/GetElectionDates", { headers });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        const actualDate = new Date(data.actualDate);
        const startDate = new Date(data.startDate);
        const endDate = new Date(data.endDate);

        const isSemanaVotacao = actualDate > startDate && actualDate < endDate;

        this.setState({
            actualDate: data.actualDate,
            startDate: data.startDate,
            endDate: data.endDate,
            votePortalUrl: data.voteUrl,
            loading: false,
            error: false
        });

        if (isSemanaVotacao) {
            this.GetVoteEligibility();
        }

    } catch (error) {
        console.error("Error fetching election dates:", error);

        this.setState({
            loading: false,
            error: true
        });

        sendLogError(error.message, "GetElectionDates");
    }
  }

  async GetVoteEligibility() {
    try {
        const { idToken, selectedUser } = this.context;
        const { associateID } = selectedUser;

        const headers = {
            Authorization: `Bearer ${idToken}`
        };

        const response = await fetch(
            `/Elections/GetVoteEligibility?associateReference=${associateID}`,
            { headers }
        );

        if (!response.ok) {
            console.warn("Vote eligibility check failed:", response.status);
            return;
        }

        const data = await response.json();

        this.setState({
            canVote: data?.canVote ?? false,
            voteSubmitted: data?.submitedVote ?? false,
        });

    } catch (error) {
        console.error("Error fetching vote eligibility:", error);

        // intencionalmente não quebra UI
        sendLogError(error.message, "GetVoteEligibility");
    }
  }

  async GetCandidatesList() {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
        };

        const response = await fetch("/Elections/GetCandidatesList", {
            headers,
        });

        if (!response.ok) {
            console.warn("Candidates list fetch failed:", response.status);
            return;
        }

        const data = await response.json();

        this.setState({
            listasAssembleiaGeral: data?.generalMeetingList ?? [],
            listasAssembleiaRepresentantes: data?.meetingRepresentativesList ?? [],
        });

    } catch (error) {
        console.error("Error fetching candidates list:", error);

        // intencionalmente não quebra UI
        sendLogError(error.message, "GetCandidatesList");
    }
  }
}

Eleicoes.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Eleicoes);
